import { AiOutlineFileText, AiOutlineNumber } from 'react-icons/ai';
import { ReportingControllerBaseConfig } from '../../../base';
import { RecordFormController } from './recordFormInterface';
import { RecordFormViewProps } from './recordFormProps';
import { Property } from '@varos/research-sdk-api';
import { BsCalendar, BsCheck, BsLink, BsTextLeft } from 'react-icons/bs';
import { assertNever } from '@varos/util-typescript';
import {
    MdAccessTime,
    MdOutlineAlternateEmail,
    MdOutlineArrowDropDownCircle,
    MdOutlineEmail,
    MdOutlineManageSearch,
    MdOutlinePerson,
    MdStarBorder,
} from 'react-icons/md';
import { BiSolidTime } from 'react-icons/bi';

export function createRecordFormController(
    config: ReportingControllerBaseConfig
): RecordFormController {
    const {
        kernel: {
            provider: { createFormController },
        },
    } = config;

    const formController = createFormController();

    function getIcon(property: Property) {
        if (property.type === 'text' || property.type === 'string') {
            return BsTextLeft;
        }
        if (property.type === 'integer' || property.type === 'float') {
            return AiOutlineNumber;
        }
        if (property.type === 'email') {
            return MdOutlineAlternateEmail;
        }
        if (property.type === 'boolean') {
            return BsCheck;
        }
        if (property.type === 'date') {
            return BsCalendar;
        }
        if (property.type === 'datetime') {
            return MdAccessTime;
        }
        if (property.type === 'link') {
            return BsLink;
        }
        if (property.type === 'rating') {
            return MdStarBorder;
        }
        if (property.type === 'relation') {
            return MdOutlineManageSearch;
        }
        if (property.type === 'enum') {
            return MdOutlineArrowDropDownCircle;
        }
        if (property.type === 'user') {
            return MdOutlinePerson;
        }
        if (property.type === 'snippet') {
            return AiOutlineFileText;
        }
        assertNever(property);
    }
    return {
        useProps(context, item, props): RecordFormViewProps {
            const form = formController.useProps(props.form);
            const { isDirty } = form.form.formState;

            return {
                form,
                collection: {
                    label: item.collection.display_name,
                },
                clear: !isDirty
                    ? null
                    : {
                          label: 'Reset',
                          button: {
                              onClick: form.reset,
                          },
                      },
                save: {
                    label: 'Save record',
                    button: {
                        ...form.getSubmitButtonProps(),
                        isDisabled: !isDirty || form.getSubmitButtonProps().isDisabled,
                    },
                },
                property: {
                    items: item.collection.properties.map((property) => ({
                        id: property.key,
                        label: property.display_name,
                        description: property.description,
                        Icon: getIcon(property),
                        value: {
                            collection: item.collection.id,
                            item: {
                                property: property,
                                value: props.values.properties[property.key] ?? null,
                            },
                            onChange(value) {
                                console.log('updating value', property.display_name, {
                                    value,
                                });
                                props.property.onChange({
                                    ...props.property.value,
                                    [property.key]: value,
                                });
                            },
                        },
                    })),
                },
            };
        },
    };
}
